<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between">
          <h5 class="mb-4">
            <strong>Detail Artikel</strong>
          </h5>
          <a-radio-group v-model="category">
            <a-radio-button disabled v-if="category === null" value="umum">
              Artikel Umum
            </a-radio-button>
            <a-radio-button disabled v-if="category" value="khusus">
              Artikel Khusus
            </a-radio-button>
          </a-radio-group>
        </div>
        <a-spin v-if="isLoading" />
        <a-form :form="form" @submit="handleSubmit" v-if="!isLoading">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Judul Artikel"
          >
            <a-input
              :disabled="submitting"
              placeholder="Judul Artikel"
              v-decorator="[
                'title',
                {
                  rules: [
                    { required: true, message: 'Judul artikel harus diisi!' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Isi Artikel"
          >
            <a-textarea
              rows="6"
              :disabled="submitting"
              placeholder="Isi Artikel"
              v-decorator="['body']"
            />
            <!-- <editor
              v-model="articleBody"
              @change="onChangeBody"
              apiKey="v4o73bx9umvdzvgxil8eah6wgqbg3zz251aygdfvekzx7tbb"
              :init="{
                fontsize_formats: `8pt 10pt 12pt 14pt 17pt 18pt 24pt 26pt 36pt`,
                font_formats: `Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Montserrat=montserrat; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats`,
                content_style: `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');`,
                height: 500,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap textcolor image code',
                  'searchreplace visualblocks code fullscreen',
                  'print preview anchor insertdatetime media',
                  'paste code help wordcount table'
                ],
                toolbar:
                  'undo redo | fontselect | link image | fontsizeselect | formatselect | bold italic | styleselect fontselect fontsizeselect | forecolor backcolor \
                  alignleft aligncenter alignright | \
                  table tabledelete | tableprops tablerowprops tablecellprops | tablemergecells | tablecellbordercolor | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol \
                  bullist numlist outdent indent | help'
              }"
            >
            </editor> -->
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Gambar"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'image',
                {
                  valuePropName: 'image',
                  rules: [
                    { required: true, message: 'Gambar artikel harus diisi!' },
                  ],
                },
              ]"
              name="upload"
              :action="action"
              :file-list="fileList"
              @change="handleChange"
              list-type="picture"
            >
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Thumbnail"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'thumbnailImage',
                {
                  valuePropName: 'thumbnailImage',
                  rules: [
                    { required: true, message: 'Gambar artikel harus diisi!' },
                  ],
                },
              ]"
              name="upload"
              :action="actionThumbnail"
              :file-list="fileList2"
              @change="handleChange2"
              list-type="picture"
            >
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Penulis"
          >
            <a-input
              :disabled="submitting"
              placeholder="Penulis"
              v-decorator="[
                'writer',
                {
                  rules: [{ required: true, message: 'Penulis harus diisi!' }],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Tags"
          >
            <a-select
              mode="tags"
              style="width: 100%"
              :token-separators="[',']"
              v-decorator="['tags']"
            >
              <!-- <a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">
                {{ (i + 9).toString(36) + i }}
              </a-select-option> -->
            </a-select>
          </a-form-item>
          <a-form-item
            v-if="category !== null"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Program"
          >
            <a-select
              style="width: 100%"
              v-decorator="[
                'tag',
                {
                  rules: [{ required: true, message: 'Program harus diisi!' }],
                },
              ]"
            >
              <a-select-option value="TAGRISSO"> TAGRISSO </a-select-option>
              <a-select-option value="FASLODEX"> FASLODEX </a-select-option>
              <a-select-option value="LYNPARZA"> LYNPARZA </a-select-option>
              <a-select-option value="IMFINZI"> IMFINZI </a-select-option>
              <a-select-option value="CALQUENCE"> CALQUENCE </a-select-option>
            </a-select>
          </a-form-item>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="submitting"
          >
            Simpan Data
          </button>
          <button
            class="btn btn-danger px-5 m-1"
            :disabled="submitting"
            @click="
              (e) => {
                e.preventDefault()
                setModalVisible(true)
              }
            "
          >
            Hapus Data
          </button>
          <button
            class="btn btn-secondary px-5"
            :disabled="submitting"
            @click="handleCancel"
          >
            Kembali
          </button>
        </a-form>
      </div>
    </div>
    <a-modal
      title="Konfirmasi"
      :dialog-style="{ top: '20px' }"
      :visible="modalVisible"
      @ok="() => handleDelete()"
      @cancel="() => setModalVisible(false)"
    >
      Apakah Anda yakin akan menghapus data artikel
      {{ form.getFieldValue('title') }}?
    </a-modal>
  </div>
</template>
<script>
import router from '@/router'
import { getById, editById, deleteById } from '@/services/axios/api/artikel'
import { notification } from 'ant-design-vue'
import { BASE_URL } from '@/config'
// import Editor from '@tinymce/tinymce-vue'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      category: '',
      articleBody: '',
      wrapperCol,
      cityList: [],
      isLoading: true,
      submitting: false,
      action: `${BASE_URL}/upload/news`,
      // action: `${BASE_URL}/upload/news`,
      fileList: [
        {
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url: 'http://www.baidu.com/xxx.png',
        },
      ],
      actionThumbnail: `${BASE_URL}/upload/thumbnail`,
      // actionThumbnail: `${BASE_URL}/upload/thumbnail`,
      fileList2: [
        {
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url: 'http://www.baidu.com/xxx.png',
        },
      ],
      modalVisible: false,
    }
  },
  components: {
    // editor: Editor,
  },
  created() {
    this.getNewsById()
  },
  methods: {
    async getNewsById() {
      // init form field
      this.form.getFieldDecorator('title', { initialValue: '' })
      this.form.getFieldDecorator('body', { initialValue: '' })
      this.form.getFieldDecorator('image', { initialValue: '' })
      this.form.getFieldDecorator('writer', { initialValue: '' })
      this.form.getFieldDecorator('tag', { initialValue: '' })
      this.form.getFieldDecorator('tags', { initialValue: '' })
      this.form.getFieldDecorator('thumbnailImage', { initialValue: '' })

      // get data
      const res = await getById(this.$route.params.id)
      const tags = []
      for (const i in res.tags) {
        tags.push(res.tags[i].tag)
      }
      this.category = res.tag
      console.log(res)

      // set loading false
      this.isLoading = false

      if (res) {
        // set form data
        this.articleBody = res.bodyHtml
        this.form.setFieldsValue({ title: res.title })
        this.form.setFieldsValue({ body: res.body })
        this.form.setFieldsValue({
          image: { file: { response: { data: res.image } } },
        })
        this.form.setFieldsValue({
          thumbnailImage: { file: { response: { data: res.thumbnailImage } } },
        })
        this.form.setFieldsValue({ writer: res.writer })
        this.form.setFieldsValue({ tag: res.tag })
        this.form.setFieldsValue({ tags: tags })
        // this.fileList[0].url = `${BASE_URL}${res.image}`
        this.fileList[0].url = `${BASE_URL}${res.image}`
        this.fileList[0].name = res.image.split('/')[
          res.image.split('/').length - 1
        ]
        // this.fileList2[0].url = `${BASE_URL}${res.thumbnailImage}`
        this.fileList2[0].url = `${BASE_URL}${res.thumbnailImage}`
        this.fileList2[0].name = res.thumbnailImage.split('/')[
          res.thumbnailImage.split('/').length - 1
        ]
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            if (!values.body) values.body = ' '
            values.image = values.image.file.response.data
            values.thumbnailImage = values.thumbnailImage.file.response.data
            // values.bodyHtml = this.articleBody
            const res = await editById(this.$route.params.id, values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil disimpan',
                duration: 5,
              })
              router.push('/artikel')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList = fileList
    },
    handleChange2(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList2 = fileList
    },
    async handleDelete() {
      const res = await deleteById(this.$route.params.id)
      if (res && res.data) {
        notification.success({
          message: 'Sukses',
          description: 'Data berhasil dihapus',
          duration: 5,
        })
        router.push('/artikel')
      } else {
        notification.warning({
          message: 'Gagal',
          description: 'Data gagal dihapus',
          duration: 5,
        })
      }
      this.submitting = false
      this.modalVisible = false
    },
    handleCancel(e) {
      e.preventDefault()
      router.push('/artikel')
    },
    setModalVisible(modalVisible) {
      this.modalVisible = modalVisible
    },
  },
}
</script>
